var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 184,
    viewBox: "0 0 185 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_358_907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.449 77.9804C50.0656 76.9907 50.3625 75.7879 50.2027 74.509C49.9134 72.1642 48.033 70.2534 45.6882 69.926C44.1428 69.7129 42.6964 70.1696 41.6001 71.0451C37.7557 68.9059 33.2717 67.7792 28.5061 68.038C16.2189 68.6851 6.24612 78.6123 5.53813 90.8918C5.07374 98.9538 8.56042 106.239 14.2396 110.982C14.9324 111.561 15.6556 112.109 16.4169 112.604L17.3913 110.099L23.4435 94.5764L24.4636 91.9576H10.3266L13.151 85.7303H47.6752L44.7062 91.9576H31.1477L30.1276 94.5764L22.9791 112.916L22.0275 115.359C22.8497 115.641 23.6947 115.877 24.5626 116.067C26.2983 116.456 28.095 116.654 29.9449 116.638C42.6583 116.577 53.3087 106.544 54.0928 93.8532C54.4582 87.9075 52.6768 82.3806 49.449 77.9804ZM45.2619 72.5144C46.6094 72.6743 47.6524 73.8771 47.6295 75.2398C47.6295 75.4073 47.6067 75.5671 47.5762 75.7194C47.3935 76.6482 46.7312 77.4018 45.8709 77.7216C45.2543 77.95 44.5387 77.9576 43.8003 77.6607C43.0618 77.3638 42.5061 76.7015 42.3234 75.9173C42.2092 75.4453 42.2016 74.9886 42.3081 74.5622C42.5213 73.6487 43.2065 72.9103 44.0819 72.621C44.4473 72.4992 44.8508 72.4535 45.2695 72.5068L45.2619 72.5144ZM20.6344 94.584L15.2521 108.401C11.4 104.907 8.80403 100.042 8.23307 94.584H20.6344ZM11.4685 83.1191L8.21023 90.3056C9.23035 79.2746 18.5332 70.6188 29.8231 70.6188C33.5077 70.6188 36.9791 71.5399 40.0167 73.1691C39.6665 74.0141 39.5294 74.9581 39.6665 75.9478C39.9786 78.224 41.7905 80.0739 44.0591 80.4394C45.338 80.6449 46.5485 80.3937 47.5534 79.8151C48.2842 80.8504 48.9313 81.9619 49.4794 83.1191H11.4685ZM30.3255 114.02C28.6812 114.058 27.0748 113.913 25.5294 113.593L32.9367 94.5764H46.3582L50.53 85.8216C51.2837 88.2121 51.6339 90.7852 51.4968 93.4497C50.9259 104.717 41.6001 113.761 30.3179 114.02H30.3255Z",
    fill: "#DBDBDB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_358_907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.4858 98.0858H67.7806V88.6078H65.6414V87.032H71.6403V88.6078H69.4858V98.0858Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4941 95.6802L80.0449 98.0858H78.3701L80.4941 87.032H82.8312L85.0694 98.0858H83.3108L82.8465 95.6802H80.4941ZM81.6513 89.1484L80.7529 94.1043H82.5572L81.6436 89.1484H81.6513Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5778 96.51H97.9732V98.0858H92.8726V87.032H94.5778V96.51Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.375 96.51H110.77V98.0858H105.67V87.032H107.375V96.51Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.568 95.6802L120.119 98.0858H118.444L120.568 87.032H122.905L125.143 98.0858H123.385L122.92 95.6802H120.568ZM121.725 89.1484L120.827 94.1043H122.631L121.718 89.1484H121.725Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.947 87.032H135.649C137.819 87.032 138.846 88.1435 138.846 90.4958V94.622C138.846 96.9744 137.819 98.0858 135.649 98.0858H132.947V87.032ZM135.497 96.51C136.707 96.51 137.134 95.8781 137.134 94.1576V90.9602C137.134 89.2169 136.7 88.6078 135.497 88.6078H134.652V96.51H135.497Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.743 98.0858H147.038V87.032H148.743V98.0858Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.911 87.032V94.523C162.911 95.9162 162.743 96.6242 162.279 97.256C161.799 97.9031 160.985 98.2533 159.995 98.2533C159.005 98.2533 158.175 97.9031 157.688 97.256C157.224 96.6242 157.056 95.9162 157.056 94.523V87.032H158.762V94.8047C158.762 96.1141 159.112 96.647 159.987 96.647C160.863 96.647 161.198 96.1141 161.198 94.8047V87.032H162.903H162.911Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.255 98.0858H177.634V89.9477L175.715 98.0858H174.756L172.853 89.9477V98.0858H171.231V87.032H173.736L175.259 93.9749L176.796 87.032H179.263V98.0858H179.255Z",
    fill: "#DBDBDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_358_907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.6384,
    height: 48.6384,
    fill: "white",
    transform: "translate(5.5 68)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_358_907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113.614,
    height: 11.2213,
    fill: "white",
    transform: "translate(65.6414 87.032)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner9);
export default __webpack_public_path__ + "static/media/partner-9.4d06a2b100538a88c03bc79a21a1d0e2.svg";
export { ForwardRef as ReactComponent };